import { MIME_TYPE } from '../types';

const logsPrefix = '[proxyFetch]';

const logResponse = (url: string, statusCode: number, body: unknown, method = 'GET'): void => {
    const message = `${logsPrefix} ${method} - ${url} [${statusCode}]`;

    if (statusCode >= 400) {
        console.error(message, body);
        return;
    }

    console.info(message, body);
};

const headersToObject = (headers: Headers): Record<string, string> => {
    const headersObject: Record<string, string> = {};

    headers.forEach((value, key) => {
        headersObject[key] = value;
    });

    return headersObject;
};

export type ProxyFetchResponse = {
    statusCode: number;
    headers: Record<string, string>;
    body: unknown;
};

export const proxyFetch = async (url: URL | RequestInfo, init?: RequestInit): Promise<ProxyFetchResponse> => {
    try {
        const response = await fetch(url, init);

        const contentType = response.headers.get('content-type');
        const isJson = contentType?.includes(MIME_TYPE.json);

        let body: unknown;

        if (isJson) {
            body = await response.json();
        } else {
            const text = await response.text();

            body = text ? { message: text } : {};
        }

        logResponse(url.toString(), response.status, body, init?.method);

        return {
            statusCode: response.status,
            headers: headersToObject(response.headers),
            body,
        };
    } catch (error) {
        console.error(error);

        throw error;
    }
};
